import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { BackordersDashboardFilters } from "modules/BackordersDashboard/queryKeys";

export const useExportBackordersMutation = () =>
  useTypedMutation<BackordersDashboardFilters, void>({
    mutationFn: async filters => {
      await ApiInstance.post("/backorder/export/enqueue", filters);
    },
    onSuccess: () => null
  });
